import { fetchJSON as fetchAPI } from './client';

export type ScopeItem = {
  key: string;
  name: string;
  category: string;
  priority: string;
  description?: string;
};

export type FeaturePRD = {
  key: string;
  name: string;
  category: string;
  priority: string;
  release_version: string;
  problem_statement: string;
  business_value: string;
  customer_persona: string;
  success_metrics?: string[];
  kpis?: string[];
  detailed_behaviour?: string[];
  validations?: string[];
  business_rules?: string[];
  permissions?: string[];
  configurations?: string[];
  dependencies?: string[];
  edge_cases?: string[];
  failure_handling?: string[];
  recovery?: string[];
  screen_behaviour?: string[];
  keyboard_shortcuts?: string[];
  loading_states?: string[];
  empty_states?: string[];
  error_states?: string[];
  accessibility?: string[];
  animations?: string[];
  interaction_rules?: string[];
  ui_route?: string;
  go_architecture?: string;
  packages?: string[];
  services?: string[];
  repositories?: string[];
  cqrs: boolean;
  events?: string[];
  background_jobs?: string[];
  caching?: string[];
  performance_targets?: string[];
  tables?: string[];
  columns?: string[];
  indexes?: string[];
  constraints?: string[];
  relationships?: string[];
  partitioning?: string;
  migration?: string;
  archiving?: string;
  rest_endpoints?: string[];
  websocket_channels?: string[];
  event_topics?: string[];
  request_models?: string[];
  response_models?: string[];
  error_codes?: string[];
  rate_limits?: string;
  authorization?: string;
  dna_usage?: string;
  recommendation_hooks?: string[];
  ai_context?: string[];
  learning_hooks?: string[];
  future_experiments?: string[];
  unit_tests?: string[];
  integration_tests?: string[];
  e2e_tests?: string[];
  load_tests?: string[];
  security_tests?: string[];
  performance_tests?: string[];
  acceptance_tests?: string[];
  regression_tests?: string[];
  definition_of_done?: string[];
  business_validation?: string[];
  performance_criteria?: string[];
  security_criteria?: string[];
  production_readiness?: string[];
};

export type FeatureValidation = {
  feature_key: string;
  valid: boolean;
  business_objective: boolean;
  functional_requirements: boolean;
  ux_requirements: boolean;
  backend_requirements: boolean;
  database_defined: boolean;
  apis_defined: boolean;
  testing_defined: boolean;
  acceptance_criteria: boolean;
  gaps?: string[];
  evaluated_at: string;
};

export type PRDDashboard = {
  prd_id: string;
  tenant_id: string;
  version: string;
  depends_on: string[];
  scope_features: number;
  feature_prds: number;
  platform_features: number;
  intelligence_features: number;
  ops_features: number;
  generated_at: string;
};

export type PRDBibleStatus = {
  prd_id: string;
  version: string;
  depends_on: string[];
  scope_features: number;
  feature_prds: number;
  platform_features: number;
  intelligence_features: number;
  ops_features: number;
  implementation_ready: boolean;
  no_ambiguity: boolean;
  status: string;
};

const MARKETINTEL_BASE = import.meta.env.VITE_MARKETINTEL_API ?? '/api/v1/marketintel';

function fetchMarketIntel<T>(path: string, init?: RequestInit): Promise<T> {
  return fetchAPI<T>(`${MARKETINTEL_BASE}${path}`, init);
}

export const marketplaceIntelligenceV1Api = {
  dashboard: () => fetchMarketIntel<PRDDashboard>('/prd/dashboard'),
  scope: () => fetchMarketIntel<{ scope: ScopeItem[] }>('/prd/scope').then((r) => r.scope),
  features: () => fetchMarketIntel<{ features: FeaturePRD[] }>('/prd/features').then((r) => r.features),
  feature: (key: string) => fetchMarketIntel<FeaturePRD>(`/prd/feature/${key}`),
  validateFeature: (payload: { feature_key: string; attrs: Record<string, boolean> }) =>
    fetchMarketIntel<FeatureValidation>('/prd/validate-feature', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }),
  status: () => fetchMarketIntel<PRDBibleStatus>('/prd/status'),
};
